interface LoadingRowsProps {
  label: string;
  columns?: number;
  rows?: number;
}

/** List-shaped loading state built from the admin UI's existing surface tokens. */
export function LoadingRows({ label, columns = 4, rows = 4 }: LoadingRowsProps) {
  return (
    <div role="status" aria-live="polite" aria-label={label} className="space-y-2">
      {Array.from({ length: rows }, (_, row) => (
        <div
          key={row}
          aria-hidden="true"
          className="grid gap-3 rounded-md border px-4 py-3"
          style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
        >
          {Array.from({ length: columns }, (_, column) => (
            <span
              key={column}
              className="h-4 animate-pulse rounded bg-muted motion-reduce:animate-none"
            />
          ))}
        </div>
      ))}
      <span className="sr-only">{label}</span>
    </div>
  );
}
